module.exports = __webpack_public_path__ + "img/ARCH_02_prew.4ab8b4e0.jpg";